import { UserInviteModel } from "../../entities";
import { BaseODataRepository } from "../BaseODataRepository";

export class UserInviteODataRepo extends BaseODataRepository<UserInviteModel> {
  protected baseUrl = `/odata/userinvites`;
}
